export const defaultTransComponents = { sub: <sub></sub> };
